
import React from 'react';

const StatCard = ({ title, value, icon, change, bgColor }) => (
    <div className={`bg-gradient-to-br ${bgColor} rounded-xl p-4 sm:p-6 text-white shadow-lg hover:shadow-xl transition-all duration-300`}>
        <div className="flex justify-between items-start">
            <div>
                <p className="text-white/80">{title}</p>
                <h3 className="text-2xl sm:text-3xl font-bold mt-2">{value}</h3>
            </div>
            <div className="bg-white/20 rounded-lg p-2">
                {icon}
            </div>
        </div>
        <div className="mt-4 text-white/80 text-sm">
            {change}
        </div>
    </div>
);

export default StatCard;